import {
  SIGNUP_REQUEST,
  SIGNUP_SUCCESS,
  SIGNUP_FAILURE,
  LOGIN_FAILURE,
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  FORGOTPASSWORD_FAILURE,
  FORGOTPASSWORD_REQUEST,
  FORGOTPASSWORD_SUCCESS,
  RESETPASSWORD_FAILURE,
  RESETPASSWORD_REQUEST,
  RESETPASSWORD_SUCCESS,
  SIGNUPDATA_REQUEST,
  SIGNUPDATA_SUCCESS,
  SIGNUPDATA_FAILURE,
  ACCEPTUSER_REQUEST,
  ACCEPTUSER_SUCCESS,
  ACCEPTUSER_FAILURE,
  REJECTUSER_REQUEST,
  REJECTUSER_SUCCESS,
  REJECTUSER_FAILURE,
} from '../Constants/ActionTypes';
import * as API from '../API/api.js';
import { toast } from 'react-toastify';


export const signUp = (values, navigate) => async dispatch => {
  try {
    dispatch({ type: SIGNUP_REQUEST });
    const data = await API.signUp(values);
    if (data.data.success === true) {
      toast('Successfully Signed Up.... Please wait for admin verification');
      dispatch({ type: SIGNUP_SUCCESS, payload: data });
      navigate('/login');
    } else if (data.data.success === false) {
      toast('Invalid Signup credentiails');
      dispatch({ type: SIGNUP_SUCCESS, payload: data });
      navigate('/login');
    }
  } catch (error) {
    toast('SIGNUP NOT SUCCESSFUL');
    console.log(error.message);
    dispatch({ type: SIGNUP_FAILURE });
  }
};

export const forgotPassword = (values, navigate) => async dispatch => {
  try {
    forgotPassword({ type: FORGOTPASSWORD_REQUEST });
    const data = await API.forgotPassword(values);
  
    if (data.data.success === true) {
      toast('Please check your email for reset password link');
      dispatch({ type: FORGOTPASSWORD_SUCCESS, payload: data });
      // navigate('/login');
    } 
    
   else if (data.data.success === false) {
      toast('Unable to send reset link , Please check your email and try again');
      dispatch({ type: FORGOTPASSWORD_FAILURE});
      // navigate('/login');
    } 

  } catch (error) {
    toast('Unable to send reset link , Please check your email and try again');
    console.log(error.message);
    dispatch({ type: FORGOTPASSWORD_FAILURE });
  }
};

export const resetPassword = (values, navigate,token) => async dispatch => {
  try {
    resetPassword({ type: RESETPASSWORD_REQUEST });
    const data = await API.resetPassword(values,token);
  
    if (data.data.success === true) {
      toast('Password reset successful');
      dispatch({ type: RESETPASSWORD_SUCCESS, payload: data });
      navigate('/login');
    } 
    
   else if (data.data.success === false) {
      toast('Unable to reset your password , Please try again');
      dispatch({ type: RESETPASSWORD_FAILURE});
      // navigate('/login');
    } 

  } catch (error) {
    toast('Unable to reset your password , Please try again');
    console.log(error.message);
    dispatch({ type: RESETPASSWORD_FAILURE });
  }
};


export const login = (values, navigate) => async dispatch => {
  try {
    dispatch({ type: LOGIN_REQUEST });
    const data = await API.login(values);
    // console.log(data.data.data.role)
    if (data.data.success === true) {
      toast('WELCOME');
      dispatch({ type: LOGIN_SUCCESS, payload: data.data });
      if (data.data.data.role === 'ADMIN1') navigate('/admin-dashboard-1');
      else if(data.data.data.role==='ADMIN2')navigate('/admin-dashboard-2');
      else if(data.data.data.role==='ADMIN3')navigate('/admin-dashboard-3');
      else if (data.data.data.role === 'USER') navigate('/user-dashboard');
    } else if (data.data.success === false) {
      toast('NOT ABLE TO FIND USER');
      dispatch({ type: LOGIN_FAILURE });
    }
  } catch (error) {
    toast('LOGIN NOT SUCCESSFUL');
    dispatch({ type: LOGIN_FAILURE });
  }
};

export const getSignUpInfo = (token) => async dispatch => {
  try {
    dispatch({ type: SIGNUPDATA_REQUEST });
    const data = await API.signUpData(token);
    
    if (data.data.status===true) {
      dispatch({ type: SIGNUPDATA_SUCCESS, payload: data.data.data });
      //   navigate('/')
    }
  } catch (error) {
    toast('SIGNUP NOT SUCCESSFUL');
    dispatch({ type: SIGNUPDATA_FAILURE });
  }
};

export const acceptUser =( value,token) => async dispatch => {
  try {
    dispatch({ type: ACCEPTUSER_REQUEST });
    const data = await API.acceptUser(value,token);

    if (data) {
      toast('USER ACCEPTED');
      dispatch({ type: ACCEPTUSER_SUCCESS, payload: data.data.data });
    }
  } catch (error) {
    toast('NOT SUCCESSFUL');
    dispatch({ type: ACCEPTUSER_FAILURE });
  }
};

export const rejectUser = (value ,token)=> async dispatch => {
  try {
    dispatch({ type: REJECTUSER_REQUEST });
    const data = await API.rejectUser(value,token);
    if (data) {
      toast('USER REJECTED');
      dispatch({ type: REJECTUSER_SUCCESS, payload: data.data.data });
    }
  } catch (error) {
    toast('NOT SUCCESSFUL');
    dispatch({ type: REJECTUSER_FAILURE });
  }
};
